import React from "react";
import { ProgressBar } from "@ts-digital/vrc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { FormattedMessage } from "react-intl";

const FulfilmentCard = props => {
  const {
    activitiesBar,
    isCardSelected,
    isCustomerPage,
    fulfilment,
    pointer,
    setCardSelected,
    setFulfilmentEditDialog,
    setFulfilmentRemoveDialog
  } = props;

  const isCompletedFulfilment = fulfilment => {
    if (
      fulfilment.fulfilmentCompanies === fulfilment.fulfilmentCompaniesCompleted
    ) {
      return true;
    }
    return false;
  };

  return (
    <div
      key={"fulfilment-card_" + fulfilment.fulfilmentId}
      className={"fulfilment-card"}
      style={{
        boxShadow: isCardSelected && "0px 8px 24px 0px rgba(21, 41, 53, 0.32)",
        outline: isCardSelected && "1px solid #0090d1",
        cursor: pointer ? "pointer" : "cursor"
      }}
      onClick={() => setCardSelected(fulfilment.fulfilmentId)}
    >
      {!isCustomerPage && !isCompletedFulfilment(fulfilment) && (
        <div
          className={"fulfilment-card-edit"}
          onClick={e => {
            e.stopPropagation();
            setFulfilmentEditDialog(fulfilment.fulfilmentId);
          }}
        >
          <FontAwesomeIcon icon={["far", "pencil"]} />
        </div>
      )}
      {isCustomerPage && !isCompletedFulfilment(fulfilment) && (
        <div
          className={"fulfilment-card-remove"}
          onClick={e => {
            e.stopPropagation();
            setFulfilmentRemoveDialog(fulfilment.fulfilmentId);
          }}
        >
          <FontAwesomeIcon icon={["far", "times-circle"]} />
        </div>
      )}
      <div className={"fulfilment-card-date"}>
        {moment(fulfilment.fulfilmentDeadline).format("D MMMM YYYY")}
        {moment(fulfilment.fulfilmentDeadline).isBefore() &&
          ((!activitiesBar &&
            fulfilment.fulfilmentCompaniesCompleted <
              fulfilment.fulfilmentCompanies) ||
            (activitiesBar &&
              fulfilment.fulfilmentCompletedActivities <
                fulfilment.fulfilmentActivities)) && (
          <div className={"fulfilment-card-expired"}>
            <FontAwesomeIcon icon={["fas", "exclamation-circle"]} />
          </div>
        )}
      </div>
      <div className={"fulfilment-card-title"}>{fulfilment.fulfilmentName}</div>
      {(!activitiesBar &&
        fulfilment.fulfilmentCompaniesCompleted <
          fulfilment.fulfilmentCompanies) ||
      (activitiesBar &&
        fulfilment.fulfilmentCompletedActivities <
          fulfilment.fulfilmentActivities) ? (
          <div className={"fulfilment-card-progress"}>
            <ProgressBar
              width={isCardSelected ? 198 : 200}
              percentage={
                !activitiesBar
                  ? Math.round((fulfilment.fulfilmentCompaniesCompleted /
                      fulfilment.fulfilmentCompanies) *
                      100)
                  : Math.round((fulfilment.fulfilmentCompletedActivities /
                      fulfilment.fulfilmentActivities) *
                      100)
              }
              progressBarLabel={
                <span className={"fulfilment-card-progress-text"}>
                  <FormattedMessage id="generic.completed" />{" "}
                  <b>
                    {!activitiesBar
                      ? fulfilment.fulfilmentCompaniesCompleted
                      : fulfilment.fulfilmentCompletedActivities}
                  </b>{" "}
                di{" "}
                  <b>
                    {!activitiesBar
                      ? fulfilment.fulfilmentCompanies
                      : fulfilment.fulfilmentActivities}
                  </b>
                </span>
              }
              completedElements={
                !activitiesBar
                  ? fulfilment.fulfilmentCompaniesCompleted
                  : fulfilment.fulfilmentCompletedActivities
              }
              totalElements={
                !activitiesBar
                  ? fulfilment.fulfilmentCompanies
                  : fulfilment.fulfilmentActivities
              }
            />
          </div>
        ) : (
          <div className={"fulfilment-card-completed"}>
            <FontAwesomeIcon icon={["fas", "check-circle"]} />
          </div>
        )}
    </div>
  );
};

export default FulfilmentCard;
